import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, formatError } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback (hash has session_id), skip /me check
        // AuthCallback will exchange the session_id and establish the session first.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.token) setAuthToken(data.token);
            setUser({
                id: data.id,
                email: data.email,
                name: data.name,
                role: data.role,
                restaurant_id: data.restaurant_id,
            });
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatError(e) };
        }
    };

    const setAuthFromResponse = (data) => {
        if (data.token) setAuthToken(data.token);
        setUser({
            id: data.id,
            email: data.email,
            name: data.name,
            role: data.role,
            restaurant_id: data.restaurant_id,
        });
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {
            // ignore
        }
        setAuthToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh, setAuthFromResponse }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
